import React from 'react'
import classNames from 'classnames'
import { Icon } from '@msaf/core-react'

export interface FeatureButtonProps {
  iconElement?: JSX.Element
  isActive?: boolean
  isDisabled?: boolean
  onClick: VoidFunction
}

export function FeatureButton({
  iconElement,
  isActive,
  isDisabled,
  onClick,
  children,
}: React.PropsWithChildren<FeatureButtonProps>) {
  const classes = classNames('c-feature-btn', {
    'c-feature-btn--active': isActive,
    'c-feature-btn--disabled': isDisabled,
  })

  return (
    <button className={classes} onClick={onClick} disabled={isDisabled}>
      <span className='c-feature-btn__marker-icon'>{iconElement}</span>
      <span className='c-feature-btn__label'>{children}</span>
      <Icon
        className='c-feature-btn__toggle-icon'
        icon={isActive ? 'close' : 'add'}
        ariaLabel={isActive ? 'Cancel' : 'Add feature'}
      />
    </button>
  )
}
